import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarItemAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify } = useCrudActions();

    const model = reactive({
        categoryId: StringUtils.toNumber(route.query.categoryId, null),
        categoryName: null,
        name: '',
        price: 0,
        isPublished: false,
        isNew: false,
        isDefault: false,
        isSpecial: false,
        limitSale: 0
    });

    const validations = {
        categoryId: { required },
        name: { required },
        price: { required, min: minValue(0) },
        limitSale: { required, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        canExecute: () => model.categoryId != null,
        request: () => avatarService.category.get(model.categoryId),
        onSuccess: ({ data }) => (model.categoryName = data.name),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX })
    });

    const create = excuteAndNotify({
        validator: v$,
        request: () =>
            avatarService.item.create(
                model.name,
                model.categoryId,
                model.price,
                model.isPublished,
                model.isNew,
                model.isDefault,
                model.isSpecial,
                model.limitSale
            ),
        onSuccess: ({ data: itemId }) => router.push({ name: ROUTE_NAME_AVATAR.ITEM.EDIT, params: { itemId } })
    });

    return { model, v$, fetch, create };
}
